import {
  IonBadge,
  IonCol,
  IonGrid,
  IonLabel,
  IonRow,
  IonText,
} from "@ionic/react";
import { TradeLeg } from "./type";
import { formatExpirationDate } from "./utils";

export const LegBlock = ({
  legs,
  expand,
}: {
  legs: TradeLeg[];
  expand: boolean;
}) => {
  const extractProductCode = (leg: TradeLeg) => {
    let baseSymbol = leg.symbol?.split(" ")?.[0];
    if ("WK" === leg?.metadata?.subType && baseSymbol) {
      const index = baseSymbol.lastIndexOf("W");
      if (index !== -1) {
        baseSymbol = baseSymbol.substring(0, index);
      }
    }
    return formatExpirationDate(leg.pcode, leg.term, baseSymbol);
  };

  if (!expand) {
    return null;
  }
  return (
    <>
      {legs.map((leg: TradeLeg) => {
        const productInfo = extractProductCode(leg);
        return (
          <IonGrid key={leg.idx}>
            <IonRow className="contract-header">
              <IonCol size="12">
                <IonText className="block-title">
                  <div
                    style={{
                      fontSize: "var(--one-font-size-7)",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <IonBadge
                      color="primary"
                      className="contract-code"
                      style={{
                        fontSize: "var(--one-font-size-7)",
                        flex: "none",
                        "--padding-start": "6px",
                        "--padding-end": "6px",
                      }}
                    >
                      {productInfo.code}
                    </IonBadge>
                    {productInfo.date && (
                      <span className="contract_name_sub_section_child_3">
                        {productInfo.date}
                      </span>
                    )}
                    <span>{leg.metadata?.longName}</span>
                  </div>
                </IonText>
              </IonCol>
            </IonRow>
            <IonRow className="header-row">
              <IonCol size="2">
                <IonLabel style={{ fontSize: "var(--one-font-size-7)" }}>
                  B/S
                </IonLabel>
              </IonCol>
              <IonCol size="4">
                <IonLabel style={{ fontSize: "var(--one-font-size-7)" }}>
                  C/P & STRIKE
                </IonLabel>
              </IonCol>
              <IonCol size="3">
                <IonLabel style={{ fontSize: "var(--one-font-size-7)" }}>
                  QTY
                </IonLabel>
              </IonCol>
              <IonCol size="3">
                <IonLabel style={{ fontSize: "var(--one-font-size-7)" }}>
                  PRICE
                </IonLabel>
              </IonCol>
            </IonRow>
            <IonRow className="value-row">
              <IonCol size="2">
                <IonText style={{ fontSize: "var(--one-font-size-7)" }}>
                  {leg.bs}
                </IonText>
              </IonCol>
              <IonCol size="4">
                <IonText style={{ fontSize: "var(--one-font-size-7)" }}>
                  {`${leg.pc ?? ""} ${leg.strike ?? ""}`}
                </IonText>
              </IonCol>
              <IonCol size="3">
                <IonText style={{ fontSize: "var(--one-font-size-7)" }}>
                  {leg.qty}
                </IonText>
              </IonCol>
              <IonCol size="3">
                <IonText style={{ fontSize: "var(--one-font-size-7)" }}>
                  {leg.price}
                </IonText>
              </IonCol>
            </IonRow>
          </IonGrid>
        );
      })}
    </>
  );
};
